import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import gpssystem from "../images/GPS map.jpg";
import schoolbaggpstracker from "../images/SCHOOL BAG gps tracker.jpg";
import cartruckscooter from "../images/Car Truck Scooter GPS Tracker.jpg";



function Gps() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <div className="cctvfotageberhampore">
        <div className="album py-1">

          <div className="container mt-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">GPS System</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <br />
      <div className="album py-1">

        <div className="container ">
          <div className="row">

            <div className="col-md-8">
              <h1 style={{color:"#030D54"}}> <b>Corporate Office</b></h1>
              <hr />
              <p className='justify'>Boost efficiency and security with advanced GPS tracking designed for businesses. Monitor fleet movement, employee routes, delivery timings, and asset safety in real time. Perfect for companies needing accurate, dependable tracking and reporting.</p>
              <br />
             
   <h1 style={{color:"#030D54"}}> <b>House Office</b></h1>
              <hr />
              <p className='justify'>Stay connected with your loved ones in real time. Our home GPS system offers live tracking, route history, and instant alerts to ensure safety for your family, vehicles, and valuables. Simple, reliable, and easy to use for everyday protection.</p>
              <a className='mb-3' href='tel: 9064797437'>Help Line No. 9064797437</a>
              <br/>
              <br/>
            </div>
            
            <div className="col-md-4">
                    <img src={gpssystem} className="d-block w-100" alt="gpssystem"/>

            </div>
          </div>

        </div>
      </div>
  <div className='computershopberhampore'>
        <br />
        <div className="album py-1">

          <div className="container">
            <div className="row">
              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={schoolbaggpstracker} className="card-img-top" alt="schoolbaggpstracker"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>School Bag GPS Tracker</b></h5>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mt-3" >
                <div className='card shadow'>
                  <img src={cartruckscooter} className="card-img-top" alt="cartruckscooter"/>
                  <div className='card-body'>
                    <h5 style={{ color: "darkblue" }} className='mb-1'><b>Car Truck Scooter GPS Tracker</b></h5>
                  </div>
                </div>
              </div>
           

            </div>
          </div>
        </div>
        <br />
        <br />
      </div>


    </div>
  )
}

export default Gps